
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / chevron - right","xmlns":"http://www.w3.org/2000/svg","width":"8.105","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.324.324A1.106 1.106 0 011.763.217l.124.107 5.895 5.894a1.106 1.106 0 01.107 1.439l-.107.124-5.895 5.895a1.105 1.105 0 01-1.67-1.439l.107-.124L5.436 7 .324 1.887A1.106 1.106 0 01.217.448z","fill":"#011936"}})])
          )
        }
      }
    